import React from 'react'
import { Grid } from '@material-ui/core'
import { CustomBanner, CustomPaper } from '../login/styles'
import { MaintenanceMessage } from './styles'
import CompanyLogo from '../../../app/components/companyLogo'

const MaintenanceBanner = () => (
  <CustomBanner>
    <Grid
      container
      justify="center"
      style={{
        width: '100%',
        margin: 0
      }}
    >
      <Grid item xs={12} lg={12}>
        <CustomPaper>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <CompanyLogo size="login" color />
            </Grid>
            <MaintenanceMessage>
              <p>This information is currently unavailable due to system maintenance.</p>
              <p>It will be available on Tuesday, July 6th.</p>
            </MaintenanceMessage>
          </Grid>
        </CustomPaper>
      </Grid>
    </Grid>
  </CustomBanner>
)

export default MaintenanceBanner
